/**
 * Blog Menu Active State
 * Marks the current blog menu item as active based on the URL
 */

document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname;
  const blogMenuLinks = document.querySelectorAll('.blog-menu-link');
  
  blogMenuLinks.forEach(link => {
    const linkUrl = link.getAttribute('data-button-link');
    
    if (linkUrl) {
      // Extract the path from the link URL (handle both full URLs and relative paths)
      let linkPath = linkUrl;
      try {
        const url = new URL(linkUrl, window.location.origin);
        linkPath = url.pathname;
      } catch (e) {
        // If it's already a relative path, use it as is
        linkPath = linkUrl;
      }
      
      // Check if current path matches the link path
      if (currentPath === linkPath || currentPath.startsWith(linkPath + '/')) {
        link.classList.add('active');
      }
    }
  });
});

